import * as React from "react";
import { connect } from "react-redux";
import { Button } from "carbon-components-react";
import { Save16 } from "@carbon/icons-react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import { HurdleProps } from "underwriter_dashboard/HurdleEditor";
import WVoEForEmployment from "./WVoEForEmployment";
import { updateViewingEmploymentID } from "../../actions";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");
require("../../../../assets/stylesheets/components/underwriter_dashboard/hurdle_editors/wvoe.scss");

interface HurdleEditorProps extends HurdleProps {
  dispatch?: Function;
  wvoeHurdleViewingEmploymentID: Number;
}

class WrittenVerificationOfEmploymentHurdleEditor extends React.Component<HurdleEditorProps, any> {
  constructor(props) {
    super(props);
    this.state = {
      employments: props.app.employments.filter(employment => employment.end_date === null),
      selectedIndex: props.wvoeHurdleViewingEmploymentID,
    };
  }

  onSave() {}

  handleSelect(newlySelectedIndex) {
    let value = newlySelectedIndex;
    if (value > this.state.employments.length - 1) {
      value = this.state.employments.length - 1;
    }
    this.setState({ selectedIndex: value });
    updateViewingEmploymentID(this.props.dispatch, value);
  }

  renderTabs() {
    return (
      <TabList className="tab-list">
        {this.state.employments.map((employment, index) => (
          <Tab key={index} className="tab-list__item tab-list__item--black-cutoff">
            Borrower {employment.borrower_entity}
            's Current Employment: {employment.name}
          </Tab>
        ))}
      </TabList>
    );
  }

  renderTabPanels() {
    return this.state.employments.map((employment, index) => (
      <TabPanel key={index} className="react-tabs__tab-panel tab-panel tab-panel--black-cutoff">
        <WVoEForEmployment
          app={this.props.app}
          employment={employment}
          dispatch={this.props.dispatch}
          hurdle={this.props.hurdle}
        />
      </TabPanel>
    ));
  }

  render() {
    const { app, hurdle, onHide } = this.props;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <Tabs
          className="tabs"
          selectedIndex={this.state.selectedIndex}
          onSelect={this.handleSelect.bind(this)}
          forceRenderTabPanel
        >
          {this.renderTabs()}
          {this.renderTabPanels()}
        </Tabs>

        <footer className={styles.footer}>
          <Button kind="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button kind="primary" onClick={this.onSave.bind(this)} renderIcon={Save16}>
            Save changes
          </Button>
        </footer>
      </HurdleView>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { wvoeHurdleViewingEmploymentID } = state.operator;
  return {
    ...ownProps,
    wvoeHurdleViewingEmploymentID,
  };
};

export default connect(mapStateToProps)(WrittenVerificationOfEmploymentHurdleEditor);
